import _ from 'lodash';
import { getUserSetting } from './Settings';
import { getIntl } from './IntlInstance';

export const getTagTitle = (sf) => {
  if (!sf.title) {
    return sf.label;
  }
  return `${sf.title}: ${sf.label}`;
};

export const getMatchingSearches = (selectedFilters, type) => {
  const pinnedSearches = getUserSetting('pinned_searches') ?
    getUserSetting('pinned_searches').filter(s => s.type === type) : [];

  return pinnedSearches.filter(s => {
    const selected = selectedFilters.map(sf => ({ key: sf.key, type: sf.type }));
    const pinned = s.filters.map(sf => ({ key: sf.key, type: sf.type }));

    return _.isEqual(selected, pinned);
  });
};

const filterPriority = [
  'search',
  'types',
  'deleted_by',
  'statuses',
  'extensions',
  'no_collections',
  'visibility',
  'orientation',
  'user_ids',
  'people',
  'dates',
  'original_dates',
  'expiration_dates',
  'terms',
];

export const getPinnedSearchSuggestedName = (filters, useIndexLimit = 5) => {
  const nameParts = [];
  let usedIndices = 0;

  const groupedFilters = filters.filter(f => f.type !== 'search_fields').reduce((acc, filter) => {
    if (!acc[filter.type]) {
      acc[filter.type] = [];
    }
    acc[filter.type].push(filter.label);
    return acc;
  }, {});

  const addFilterPart = (type) => {
    const intl = getIntl();
    if (groupedFilters[type] && usedIndices < useIndexLimit) {
      let value = '';

      if (type === 'search') {
        const prefix = intl.formatMessage({ defaultMessage: 'Search: ' });
        const searchValue = groupedFilters[type].join(', ');
        if (searchValue.startsWith(prefix)) {
          value = `"${searchValue}"`;
        } else {
          value = searchValue;
        }
      } else if (type === 'user_ids') {
        value = intl.formatMessage({
          defaultMessage: 'by {users}',
        }, { users: groupedFilters[type].join(', ') });
      } else if (type === 'deleted_by') {
        value = intl.formatMessage({
          defaultMessage: 'deleted by {users}',
        }, { users: groupedFilters[type].join(', ') });
      } else if (type === 'dates') {
        value = intl.formatMessage({
          defaultMessage: 'Uploaded {dates}',
        }, { dates: groupedFilters[type].join(', ') });
      } else if (type === 'original_dates') {
        value = intl.formatMessage({
          defaultMessage: 'Created {dates}',
        }, { dates: groupedFilters[type].join(', ') });
      } else if (type === 'expiration_dates') {
        value = intl.formatMessage({
          defaultMessage: 'Expires {dates}',
        }, { dates: groupedFilters[type].join(', ') });
      } else {
        value = groupedFilters[type].join(', ');
      }

      nameParts.push(value);
      usedIndices += 1;
    }
  };

  for (let i = 0; i < filterPriority.length; i += 1) {
    addFilterPart(filterPriority[i]);
    if (usedIndices >= useIndexLimit) break;
  }

  const remainingFilters = [];

  Object.keys(groupedFilters).forEach((type) => {
    if (!filterPriority.includes(type)) {
      remainingFilters.push(type);
    }
  });

  for (let i = 0; i < remainingFilters.length && usedIndices < useIndexLimit; i += 1) {
    addFilterPart(remainingFilters[i]);
  }

  const finalName = nameParts.join(', ');

  return finalName;
};
